import {Button, Container, Tooltip} from '@mantine/core';
import {IconDownload, IconDownloadOff} from '@tabler/icons-react';
import useTranslation from 'src/i18next.config';
import {useState} from 'react';
import {humanFileSize} from 'src/helpers/file.helper';
import {getTimeLeft} from 'src/helpers/time.helper';

type ExecutionDownloadButtonProps = {
    label: string;
    nbFiles: number;
    size: number;
    isDisabled: boolean;
    showMetadata: boolean;
    cleanUpDate: number | undefined;
    onClick?: (event: any) => void;
};

type TimeLeft = {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
};

export function ExecutionDownloadButton({
    label,
    nbFiles,
    size,
    isDisabled,
    showMetadata,
    cleanUpDate,
    onClick,
}: ExecutionDownloadButtonProps) {
    const [timeLeft, setTimeLeft] = useState<TimeLeft>();
    const {t} = useTranslation();
    function updateCleanUpTimeLeft() {
        if (cleanUpDate) {
            setTimeLeft(getTimeLeft(cleanUpDate));
        }
    }

    function getTooltipLabel() {
        if (timeLeft) {
            if (timeLeft.seconds >= 0) {
                return `${t('cleanupConfiguration.cleanUpExpectedTime')} ${timeLeft?.days}d ${timeLeft?.hours}h ${
                    timeLeft?.minutes
                }mn ${timeLeft?.seconds}s`;
            } else {
                return t('cleanupConfiguration.cleanUpExpectedSoon');
            }
        } else {
            return t('cleanupConfiguration.noCleanUpExpectedTime');
        }
    }

    let filesInfo = {nbFilesText: '', filesSizeText: ''};
    if (showMetadata) {
        filesInfo = {
            nbFilesText: `${t('files')}: ${nbFiles ? nbFiles : 0}`,
            filesSizeText: `${t('size')}: ${humanFileSize(size)}`,
        };
    }

    return (
        <Tooltip multiline w={300} withArrow label={getTooltipLabel()}>
            <Button
                style={{
                    width: '-moz-available',
                    inlineSize: '-webkit-fill-available',
                }}
                leftSection={isDisabled ? <IconDownloadOff size="1.5rem" /> : <IconDownload size="1.5rem" />}
                color="cyan.8"
                disabled={isDisabled}
                onClick={onClick}
                onMouseOver={updateCleanUpTimeLeft}
            >
                <Container style={{padding: 0}}>
                    <div style={{top: '-4px', fontSize: '1.1em'}}>{label}</div>
                    {showMetadata && (
                        <>
                            <div style={{color: isDisabled ? '#9e9b9b' : '#dbdbdb', fontSize: '0.9em', fontWeight: 'lighter', fontFamily: 'verdana, sans-serif'}}>
                                {filesInfo?.nbFilesText}
                            </div>
                            <div style={{color: isDisabled ? '#9e9b9b' : '#dbdbdb', fontSize: '0.9em', fontWeight: 'lighter', fontFamily: 'verdana, sans-serif'}}>
                                {filesInfo?.filesSizeText}
                            </div>
                        </>
                    )}
                </Container>
            </Button>
        </Tooltip>
    );
}
